import type { ButtonHTMLAttributes, MouseEvent } from 'react';
import { Button as Family } from '@beyond-js/ui/react';

interface Properties extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'type' | 'className'> {
	variant?: 'primary' | 'secondary' | 'quiet' | 'danger';
	/** Shows a spinner and ignores presses while the action runs; the button keeps its focus */
	busy?: boolean;
	type?: 'button' | 'submit' | 'reset';
	/** The family's shorter button, for an action inside a line of text or a dense row */
	small?: boolean;
}

/**
 * The family's button from `@beyond-js/ui`, with this application's properties. `aria-label` names a button
 * whose visible text does not say enough on its own; a busy button says it is working and ignores presses
 * (`aria-disabled`), so a double press never sends an action twice.
 */
export function Button({ variant = 'secondary', busy = false, type = 'button', small = false, 'aria-label': name, onClick, children, ...rest }: Properties) {
	const press = onClick ? (event: MouseEvent<HTMLElement>) => onClick(event as MouseEvent<HTMLButtonElement>) : null;
	return (
		<Family {...rest} variant={variant} busy={busy} type={type} small={small} name={name} onClick={press}>
			{children}
		</Family>
	);
}
